import React, { useEffect, useRef, useState } from "react";
import "react-bootstrap-typeahead/css/Typeahead.css";
import {
  FaSearch,
  FaTimes,
  FaChevronDown,
  FaEdit,
  FaEye,
  FaTrash,
} from "react-icons/fa";
import {
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import {
  formatPrice,
  formatSquareFootage,
  formatNotesDateTime,
  viewDateTimeFormat,
} from "../../utils";
import StriveNotesDrawer from "./StriveNotesDrawer";

function StriveVisionSearch(props) {
  const {
    searchType,
    fipsNumber,
    setFipsNumber,
    handleValueChange,
    handleClearInput,
    apnNumber,
    setApnNumber,
    handleSearch,
    address,
    setAddress,
    fipsError,
    apnError,
    searchError,
    addressError,
    selectedProperty,
    showPropertyPanel,
    suggestions,
    handleSuggestionClick,
    isSuggestionSelected,
    propertyNotes,
    showAddNotes,
    setIsShowAddNotes,
    setNotesId,
    setTextInput,
    handleDeleteNote,
    loggedinuser,
    setIsNotesReadOnly,
    county_Url
    
  } = props;
  const [expandedNoteId, setExpandedNoteId] = useState(null);


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch("");
    }
  };





  const handleInputChange = (e) => {
    setAddress(e.target.value); // Update query on input change
    isSuggestionSelected.current = false; // Reset suggestion selection tracking
  };
  const baseUrl = window.location.origin.includes("localhost")
  ? "http://localhost"
  : window.location.origin.includes("app-test")
  ? "https://app-test.strivere.com"
  : "https://app.strivere.com";

  return (
    <React.Fragment>
      <div className="search-bar-container">
        <div className="custom-search-bar">
          {/* Dropdown */}
          {/* <div className="dropdown">
             <select
              className="custom-dropdown"
              value={searchType}
              onChange={(e) => handleValueChange(e)}
            >
              <option value="Address">Address</option>
              <option value="FIPS">FIPS-APN</option>
            </select> 
          </div> */}
          {/* <span className="custom-dropdown">Address</span> */}
          {/* Conditional Inputs */}
          {searchType === "FIPS" && (
            <div className="fips-inputs">
              <div className="input-wrapper">
                <input
                  type="text"
                  className="custom-search-input"
                  placeholder="FIPS Number"
                  value={fipsNumber}
                  onChange={(e) => setFipsNumber(e.target.value)}
                  style={{ marginRight: "10px" }} // Add margin for spacing
                  onKeyDown={handleKeyDown}
                />
                {fipsNumber && (
                  <button
                    className="clear-input-button"
                    onClick={() => handleClearInput("FIPS")}
                  >
                    <FaTimes height={16} width={16} />
                  </button>
                )}
              </div>
              <div className="input-wrapper">
                <input
                  type="text"
                  className="custom-search-input"
                  placeholder="APN Number"
                  value={apnNumber}
                  onChange={(e) => setApnNumber(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                {apnNumber && (
                  <button
                    className="clear-input-button"
                    onClick={() => handleClearInput("APN")}
                  >
                    <FaTimes height={16} width={16} />
                  </button>
                )}
              </div>
              <button
                className="search-icon-button"
                onClick={() => handleSearch("")}
              >
                <FaSearch />
              </button>
            </div>
          )}

          {searchType === "Address" && (
            <div className="single-input-with-icon">
              <input
                type="text"
                className="custom-search-input input-wrapper"
                placeholder={
                  searchType === "Address"
                    ? "Enter Address"
                    : "Select Address or FIPS..."
                }
                value={searchType === "Address" ? address : ""}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
              />
              {address && (
                <button
                  className="clear-input-button"
                  onClick={() => handleClearInput("Address")}
                >
                  <FaTimes />
                </button>
              )}
              <button
                className="search-icon-button"
                onClick={() => handleSearch("")}
              >
                <FaSearch />
              </button>
              {suggestions.length > 0 && (
                <ul className="suggestions-list">
                  {suggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      className="suggestion-item"
                      onClick={() => handleSuggestionClick(suggestion)}
                    >
                      {suggestion}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="display-error">
        {fipsError && <div className="error-message">{fipsError}</div>}
        {apnError && <div className="error-message">{apnError}</div>}
        {searchError && <div className="error-message">{searchError}</div>}
        {addressError && !fipsError && !apnError && (
          <div className="error-message">{addressError}</div>
        )}
      </div>
      {selectedProperty && showPropertyPanel && (
        <div
          style={{
            position: "absolute",
            top: "128px",
            left: "12px",
          }}
        >
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={
                <FaChevronDown style={{ width: "16px", height: "16px" }} />
              }
              aria-controls="panel1-content"
              id="panel1-header"
              style={{
                minHeight: 0,
                maxHeight: 40,
              }}
            >
              <span>
                <b>Property Details</b>
              </span>
            </AccordionSummary>
            <AccordionDetails className="details-card">
              <div className="details-card-content">
                {/* <h3>Owner Information:</h3>
                <p>{selectedProperty.owner}</p>
                <p>{selectedProperty.ownerAddress}</p>
                <p>{selectedProperty.ownerStreetAddress}</p>
                <p>{`${selectedProperty.ownerLocality} ${selectedProperty.ownerRegionCode} ${selectedProperty.ownerPostalCode}`}</p> */}
                <h3><a
                  target="_blank"
                  style={{ color: "#90C54B"}}
                  jstcache="6"
                  href={`https://www.google.com/maps?q=${selectedProperty.lat},${selectedProperty.lng}`}
                  tabindex="0"
                >
                  {/* {selectedProperty.address} */}
                  {"Property Information:"}
                </a></h3>
                {/* <p>{selectedProperty.address}</p> */}
                {selectedProperty.name && <p>
                  <b>Name:</b> {selectedProperty.name}
                </p>}
                <p>
                  <b>Building Size:</b>{" "}
                  {formatSquareFootage(
                    selectedProperty.livingArea
                  )}
                </p>
                <p>
                  <b>Year Built:</b> {selectedProperty.yearBuilt}
                </p>
                <p>
                  <b>Lot Size:</b>{" "}
                  {selectedProperty.lotSize }
                  {/* &&
                    (
                      (selectedProperty.lotSize * 3.28084 * 3.28084) /
                      43560
                    ).toFixed(2)} */}
                  {" Acres"}
                </p>
                <p>
                  <b>Assessed Value ({selectedProperty.assessedalueYear}):</b>{" "}
                  {formatPrice(selectedProperty.assessedValue)}
                </p>
              <p>
  {county_Url ? (
    <b>
      <a
        href={county_Url}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#90C54B",
          cursor: "pointer",
          textDecoration: "none",
        }}
      >
        Parcel Number (APN):
      </a>
    </b>
  ) : (
    <b>Parcel Number (APN):</b>
  )}
  {selectedProperty.apn}
</p>



                <h3>
                  {selectedProperty && selectedProperty.arcimedes_row_id ? (
                    <a
                      target="_blank"
                      style={{ color: "#90C54B" }}
                      href={`${baseUrl}/property/${selectedProperty.arcimedes_row_id}`}
                      rel="noopener noreferrer"
                    >
                      Last Sale:
                    </a>
                  ) : (
                    "Last Sale:"
                  )}
                </h3>
                <p>
                  <b>Price:</b> {formatPrice(selectedProperty.lastSalePrice)}
                </p>
                <p>
                  <b>Cap Rate: {formatPrice(selectedProperty.capRate)}</b>
                </p>
                <p>
                  <b>Sale Date: </b>
                  {viewDateTimeFormat(selectedProperty.saleDate)}
                </p>
                <p>
                  <b>Seller:</b>{" "}
                  {selectedProperty.seller &&
                    selectedProperty.seller.replace(/,+$/, "")}
                </p>
                <p>
                  <b>Lender:</b> {selectedProperty.lender}
                </p>
                <p>
                  <b>Loan Value:</b>{" "}
                  {formatPrice(selectedProperty.loanValue)}
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingBottom: "12px",
                  }}
                >
                  <h3>Property Notes:</h3>
                  <span className="view-link-propertyNotes">
                    <a style={{marginLeft:"80px",marginTop:"6px" }}
                      //target="_blank"
                      jstcache="6"
                      href="#"
                      tabindex="0"
                      
                      onClick={() => {
                        setNotesId("");
                        setIsShowAddNotes(!showAddNotes);
                        setIsNotesReadOnly(false);
                      }}
                    >
                      <span> Add Notes </span>
                    </a>
                  </span>
                    <StriveNotesDrawer
                      expandedNoteId={expandedNoteId}
                      propertyNotes={propertyNotes}
                      setExpandedNoteId={setExpandedNoteId}
                      setNotesId={setNotesId}
                      setTextInput={setTextInput}
                      setIsShowAddNotes={setIsShowAddNotes}
                      setIsNotesReadOnly={setIsNotesReadOnly}
                      loggedinuser={loggedinuser}
                      handleDeleteNote={handleDeleteNote}
                      showPorpertyNotes={true}
                    />
                </div>

                {/* {propertyNotes &&
                  propertyNotes.length > 0 &&
                  propertyNotes.map((item) => {
                    return (
                      <React.Fragment>
                        <p
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <b style={{ width: "25%" }}>{item.CREATED_BY}: </b>
                          <Typography
                            component="span"
                            variant="body2"
                            style={{
                              width: "40%",
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              WebkitLineClamp: 2, // Limit the text to 2 lines
                              textOverflow: "ellipsis", // Show ellipsis when the text exceeds 2 lines
                            }}
                          >
                            {item.NOTES}
                          </Typography>
                          <Typography
                            component="span"
                            variant="body2"
                            style={{
                              width: "25%",
                              padding: "0px 4px",
                            }}
                          >{`${formatNotesDateTime(item.CREATED)}`}</Typography>
                          <div style={{ display: "flex", width: "15%" }}>
                            {loggedinuser == item.CREATED_BY ? (
                              <button
                                style={{
                                  cursor: "pointer",
                                  fontSize: "15px",
                                  color: "black",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  display: "flex",
                                  alignItems: "right",
                                  gap: "4px",
                                  padding: "4px",
                                }}
                                onClick={() => {
                                  setNotesId(item.ARCIMEDES_ROW_ID);
                                  setTextInput(item.NOTES);
                                  setIsShowAddNotes(true);
                                  setIsNotesReadOnly(false);
                                }}
                              >
                                <FaEdit />
                              </button>
                            ) : (
                              <button
                                style={{
                                  cursor: "pointer",
                                  fontSize: "15px",
                                  color: "black",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  display: "flex",
                                  alignItems: "right",
                                  gap: "4px",
                                  padding: "4px",
                                }}
                                onClick={() => {
                                  setNotesId(item.ARCIMEDES_ROW_ID);
                                  setTextInput(item.NOTES);
                                  setIsShowAddNotes(true);
                                  setIsNotesReadOnly(true);
                                }}
                              >
                                <FaEye />
                              </button>
                            )}
                            {loggedinuser == item.CREATED_BY && (
                              <button
                                style={{
                                  cursor: "pointer",
                                  fontSize: "15px",
                                  color: "black",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  display: "flex",
                                  alignItems: "right",
                                  gap: "4px",
                                  padding: "4px",
                                }}
                                onClick={() => handleDeleteNote(item)}
                              >
                                <FaTrash />
                              </button>
                            )}
                          </div>
                        </p>
                        <Divider />
                      </React.Fragment>
                    );
                  })} */}
                {propertyNotes &&
                  propertyNotes.length > 0 &&
                  propertyNotes.map((item) => {
                    const name = item.CREATED_BY;
                    const formattedName = name && name.charAt(0).toUpperCase() + name.slice(1);
                    const formattedText = `${formatNotesDateTime(item.CREATED)} ${name}: ${item.NOTES}`;
                    const isExpanded = expandedNoteId === item.ARCIMEDES_ROW_ID;
                    const maxChars = 80;
                    let truncatedText = formattedText;

                    if (!isExpanded) {
                      const lines = formattedText.split("\n");
                      if (lines.length > 2) {
                        truncatedText = lines.slice(0, 2).join("\n");
                      } else if (formattedText.length > maxChars) {
                        truncatedText = formattedText.substring(0, maxChars) + "...";
                      }
                    }

                    return (
                      <React.Fragment key={item.ARCIMEDES_ROW_ID}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                          }}
                        >
                          {/* <div style={{ flex: 1, marginRight: "8px" }}>
                          
                            
                            <Typography
                              component="span"
                              variant="body2"
                              style={{
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              {formattedText}
                            </Typography>
                            {formattedText && (formattedText.split("\n").length > 2 || formattedText.length > 80) ? (
                              <button
                                onClick={() =>
                                  setExpandedNoteId(isExpanded ? null : item.ARCIMEDES_ROW_ID)
                                }
                                style={{
                                  padding: 0,
                                  border: "none",
                                  background: "none",
                                  color: "blue",
                                  cursor: "pointer",
                                  fontSize: "13px",
                                  marginTop: "4px",
                                }}
                              >
                                {isExpanded ? "Less" : "More"}
                              </button>
                            ) : null}
                          </div> */}

                          {/* <div style={{ display: "flex", gap: "4px" }}>
                            <button
                              style={{
                                cursor: "pointer",
                                fontSize: "15px",
                                color: "black",
                                backgroundColor: "transparent",
                                border: "none",
                                padding: "4px",
                              }}
                              onClick={() => {
                                setNotesId(item.ARCIMEDES_ROW_ID);
                                setTextInput(item.NOTES);
                                setIsShowAddNotes(true);
                                setIsNotesReadOnly(loggedinuser !== item.CREATED_BY);
                              }}
                            >
                              {loggedinuser === item.CREATED_BY ? <FaEdit /> : <FaEye />}
                            </button>
                            {loggedinuser === item.CREATED_BY && (
                              <button
                                style={{
                                  cursor: "pointer",
                                  fontSize: "15px",
                                  color: "black",
                                  backgroundColor: "transparent",
                                  border: "none",
                                  padding: "4px",
                                }}
                                onClick={() => handleDeleteNote(item)}
                              >
                                <FaTrash />
                              </button>
                            )}
                          </div> */}
                        </div>
                        <Divider />
                      </React.Fragment>
                    );
                  })}

              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      )}
    </React.Fragment>
  );
}

export default StriveVisionSearch;
